<template>
<body style="background-color:#e6f0f5;">
  <div class="more_region">
    <table>
      <tr :key="index" v-for="(items,index) in nations_group">
        <td :key="index+'-'" v-for="(item,index) in items">
          <a @click="selectRelativeCity(item)" href="javascript:void(0);">{{item}}</a>
        </td>
      </tr>
    </table>
  </div>
</body>
</template>
<script>
export default {
  name: 'MoreRegion',
  componentName: 'MoreRegion',
  data () {
    return {
      get_visa_nations_url: 'visa/visa_nations',
      nations: ['000', '000', '000', '000', '000', '000', '000', '000', '000', '000', '000'],
      nations_group: [],
      init: 1,
      url_name: 'visaRouteList',
      route_id: 0,
      param: {
        relative_city: ''
      }
    }
  },
  created () {
    this.init = this.$route.query.init ? this.$route.query.init : this.init
    this.route_id = this.$route.query.route_id
    this.initUrl()
    this.$myGet(this.get_visa_nations_url)
      .then(res => {
        this.nations = res.response.data.visa_nations
        this.nationsGroup()
      })
      .catch(err => {
        this.$msg('[' + err.status + ']' + err.message, 'error')
      })
  },
  methods: {
    nationsGroup () {
      var array = []
      var arrayChild = []
      for (var i = 0; i < this.nations.length; i++) {
        if (i % 4 == 0) {
          arrayChild = []
          array.push(arrayChild)
        }
        arrayChild.push(this.nations[i])
      }
      this.nations_group = array
    },
    initUrl () {
      if (this.init == 1) {
        this.url_name = 'visaRouteList'
      } else if (this.init == 2) {
        this.url_name = 'visaInterviewDate'
        this.param['route_id'] = this.route_id
      } else if (this.init == 3) {
        this.url_name = 'commonProblems'
      }
    },
    selectRelativeCity (relative_city) {
      this.param.relative_city = relative_city
      this.$pushByName(this.url_name, this.param)
    }
  }
}
</script>
<style scoped>
@import '../../assets/css/pages/html/three.css';
</style>



// WEBPACK FOOTER //
// src/pages/common/moreRegion.vue